module.exports = "/_next/static/images/e98cdbafa3a9161f92e25b37fb67081c-Nubank_HickDuarte_54700_md.jpg.webp";